/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
export default class MovieClipSequence extends PIXI.Container {
    constructor(textures, name) {
        super();

        /**
         * @type {object} textures
         */
        this.textures = {};

        textures && this.addTextures(textures, name);
    }

    /**
     * @param {Array.<PIXI.Texture>} textures
     * @param {string} [name]
     */
    addTextures(textures, name) {
        name = name || "default";
        this.textures[name] = textures;
    }

    /**
     * @param {string} [name]
     */
    removeTextures(name) {
        name = name || "default";
        this.textures[name] = null;
    }

    /**
     */
    removeAllTextures() {
        this.textures = {};
    }
}